import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel
    extendedStyles?: ProductDescriptionStyles;
    sourceName: string;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {

    const location = getLocation(state)?.pathname;
    const session= state.context.session;
    return {
        location,
        session
    };
};
export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}
export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            color: "text.main",
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                display: -webkit-box;
                line-clamp: 5;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           line-clamp: 2;
                           -webkit-line-clamp: 2;
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ])}
            }}
            `,
        },
    },
};
const ProductDescription: FC<Props> = ({ product, location, extendedStyles, session, sourceName }) => {
    const [styles] = React.useState(() => mergeToNew(productDescriptionStyles, extendedStyles));
    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");

    
            const productCatologUrl = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    //ADINA-42734 : Brands routing
    let productBrandUrl = "product" in product ? product.product?.urlSegment : product.productUri;
    if ("product" in product && product.product.variantTypeId && !productBrandUrl.includes("?option=") && product.product?.canonicalUrl.includes("?option=")) {
        productBrandUrl = product.product?.canonicalUrl.replace("/product/", "").replace("/Product/", "");
    };
    let hrefValue = location.toLowerCase().includes("/catalog/shop-brands") ? location + "/" + productBrandUrl : productCatologUrl;

    const clickHandler = () => {
        sessionStorage.setItem('item_list_name', sourceName);
    };

    return hrefValue && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        <Link
            {...styles.productDetailLink}
            href={hrefValue}
            alt={`See product details for ${description}`}
            data-test-selector="productDescriptionLink"
            onClick={clickHandler}
        >
            {description}
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};


export default connect(mapStateToProps)(ProductDescription);

